import FlexDetailsTicketSelector from './FlexDetailsTicketSelector';
import getUserConfirmation from '../shared/getUserConfirmation';

const { messaging } = window.tnew.ui;

/** @typedef {import("../shared/FlexSessionService").default} FlexSessionService */

class FlexDetails {
  /**
   * @param {string} token
   * @param {number} packageId
   * @param {string} reloadKey
   * @param {FlexSessionService} service
   */
  constructor(token, packageId, reloadKey, service) {
    this.token = token;
    this.packageId = packageId;
    this.reloadKey = reloadKey;
    this.service = service;

    this.ticketSelector = new FlexDetailsTicketSelector({
      onSubmit: (event) => {
        event.preventDefault();
        this.saveSeatingOptions(event.target);
      },
    });
  }

  getRequestBody() {
    const data = this.ticketSelector.getRequestData();

    return {
      priceTypes: data.allPricetypeQuantities.filter(i => i.quantity > 0),
      specialRequests: data.specialRequests,
    };
  }

  saveSeatingOptions = async ($trigger) => {
    const seatingOptions = this.getRequestBody();

    try {
      const saveResponse = await this.service.setSeatingOptions(seatingOptions);

      const status = saveResponse.status;
      const confirmationContent = saveResponse.data;
      let url = saveResponse.url;

      if (status === 'Continue') {
        localStorage.setItem(this.reloadKey, 'true');

        window.location.href = url;
        return;
      }

      if (status === 'MosChange') {
        messaging.addAlert(saveResponse.message, true);
        return;
      }

      if (status === 'NeedsConfirmation') {
        const userConfirmed = await getUserConfirmation($trigger, confirmationContent);

        if (userConfirmed) {
          const confirmationResponse = await this.service.setSeatingOptionsRemovePackageConfirmed(seatingOptions);

          localStorage.setItem(this.reloadKey, 'true');

          url = confirmationResponse.url;
        }

        window.location.href = url;
        return;
      }

      throw new Error(saveResponse.message);
    } catch (err) {
      messaging.addError(err.message, true);
    }
  };
}

export default FlexDetails;
